import { css } from 'styled-components'

// Shared by the app shell (view wrappers) and the word-cloud chrome (Hud):
// absolutely positioned, click-through by default, HUD typeface.
//
// The line-height MUST stay unitless. An `em` value computes to a fixed length
// here (1.1 × 16px ≈ 18px) and inherits as that length, so a view's 2rem
// heading got 18px leading and its lines overlapped. A unitless number
// inherits as a number, so every element multiplies it by its own font size.
export const base = css`
  font-family: 'Teko', sans-serif;
  position: absolute;
  font-variant-numeric: slashed-zero tabular-nums;
  line-height: 1.1;
  pointer-events: none;
  color: white;
`
